import { createStyles, WithStyles, withStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import * as React from "react";

import { Link, RelodeTheme, Text } from "../";
import { EnvelopeIcon } from "../../assets/icons";

interface EmailLinkProps extends WithStyles<typeof styles> {
    email: string;
    variant: "textOnly" | "iconOnly" | "textAndIcon";
    className?: string;
    title?: string;
    highlightType?: "external" | "internal";
    hideHighlight?: boolean;
    inline?: boolean;
    dataCy?: string;
}

const styles = (theme: RelodeTheme) =>
    createStyles({
        root: {
            display: "flex",
            alignItems: "flex-start",
        },
        text: {
            display: "inline",
        },
        icon: {
            marginRight: theme.spacing(1),
        },
        inline: {
            display: "inline-flex",
        },
    });

// TODO this is intended to replace the EmailLink component from "../links/EmailLink" once we have time;

export const EmailLink = withStyles(styles, { name: "PhoneLink" })(
    (props: EmailLinkProps) => {
        const {
            classes,
            className: classNameProp,
            email,
            variant = "textAndIcon",
            title = "send email",
            highlightType,
            hideHighlight,
            inline,
            ...passthrough
        } = props;
        const dataCy = passthrough["data-cy"];
        const iconCy = !!dataCy ? `${dataCy}-icon` : undefined;
        const textCy = !!dataCy ? `${dataCy}-text` : undefined;

        const rootClasses = classnames(classes.root, classNameProp, {
            [classes.inline]: inline,
        });

        return (
            <div className={rootClasses}>
                {variant === "iconOnly" || variant === "textAndIcon" ? (
                    <Link
                        href={`mailto:${email}`}
                        target="_blank"
                        hideHighlight={true}
                        title={title}
                        gutterBottom
                        data-cy={iconCy}
                    >
                        <EnvelopeIcon
                            className={
                                variant === "textAndIcon" ? classes.icon : ""
                            }
                            color="primary"
                        />
                    </Link>
                ) : null}
                {variant === "textOnly" || variant === "textAndIcon" ? (
                    <Link
                        href={`mailto:${email}`}
                        target="_blank"
                        highlightType={highlightType}
                        hideHighlight={hideHighlight}
                        title={title}
                        data-cy={textCy}
                    >
                        <Text variant="body1" className={classes.text}>
                            {email}
                        </Text>
                    </Link>
                ) : null}
            </div>
        );
    }
);
